import { render, staticRenderFns } from "./RecruiterRedirectRoute.vue?vue&type=template&id=3284ddbf&scoped=true"
import script from "./RecruiterRedirectRoute.vue?vue&type=script&lang=ts"
export * from "./RecruiterRedirectRoute.vue?vue&type=script&lang=ts"
import style0 from "./RecruiterRedirectRoute.vue?vue&type=style&index=0&id=3284ddbf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284ddbf",
  null
  
)

export default component.exports